<template>
    <div class="container">
      <!--   <div class="row">
            <div class="col-sm-12">
                <b-tabs v-model="tab_active">
                    <b-tab title="Fonts">
                        <b-table
                            :hover="true"
                            :items="resources.font"
                            :fields="fields"
                            :tbody-tr-class="'text-light'"
                            :thead-tr-class="'text-light'"   
                        >
                            <template #cell(active)='data'>       
                                    <b-form-checkbox
                                        v-model="data.item.active"
                                    >
                                    </b-form-checkbox>
                            </template>
                            <template #cell(options)='data'>
                                    <div class="options">
                                        <button v-if='!data.item.default' class="btn slim-btn btn-outline-light" @click="showDetail(data)"><b-icon icon="pencil-square" aria-hidden="true"></b-icon></button>
                                        <button v-if='!data.item.default' class="btn slim-btn btn-outline-light" @click="removeResource(data)"><b-icon icon="trash" aria-hidden="true"></b-icon></button>
                                        <b-badge v-if="data.item.default" variant="light">Default</b-badge>
                                    </div>
                            </template>
                            <template #row-details="row">
                                <b-card>
                                    <b-row class="mb-2">
                                        <b-col sm="3" class="text-sm-right"><b>Age:</b></b-col>
                                        <b-col>{{ row.item.name }}</b-col>
                                    </b-row>
                                </b-card>
                            </template>
                        </b-table>
                    </b-tab>
                    <b-tab title="Js">
                        <b-table
                            :hover="true"
                            :items="resources.script"
                            :fields="fields"
                            :tbody-tr-class="'text-light'"
                            :thead-tr-class="'text-light'"   
                        >
                            <template #cell(active)='data'>       
                                    <b-form-checkbox
                                        v-model="data.item.active"
                                    >
                                    </b-form-checkbox>
                            </template>
                            <template #cell(options)='data'>
                                    <div class="options">
                                        <button v-if='!data.item.default' class="btn slim-btn btn-outline-light" @click="showDetail(data)"><b-icon icon="pencil-square" aria-hidden="true"></b-icon></button>
                                        <button v-if='!data.item.default' class="btn slim-btn btn-outline-light" @click="removeResource(data)"><b-icon icon="trash" aria-hidden="true"></b-icon></button>
                                        <b-badge v-if="data.item.default" variant="light">Default</b-badge>
                                    </div>
                            </template>
                        </b-table>
                    </b-tab>
                    <b-tab title="Css">
                        <b-table
                            :hover="true"
                            :items="resources.style"
                            :fields="fields"
                            :tbody-tr-class="'text-light'"
                            :thead-tr-class="'text-light'"   
                        >
                            <template #cell(active)='data'>       
                                    <b-form-checkbox
                                        v-model="data.item.active"
                                    >
                                    </b-form-checkbox>
                            </template>
                            <template #cell(options)='data'>
                                    <div class="options">
                                        <button v-if='!data.item.default' class="btn slim-btn btn-outline-light" @click="showDetail(data)"><b-icon icon="pencil-square" aria-hidden="true"></b-icon></button>
                                        <button v-if='!data.item.default' class="btn slim-btn btn-outline-light" @click="removeResource(data)"><b-icon icon="trash" aria-hidden="true"></b-icon></button>
                                        <b-badge v-if="data.item.default" variant="light">Default</b-badge>
                                    </div>
                            </template>
                        </b-table>
                    </b-tab>
                    <b-tab title="+">
                        <div class="container-fluid">
                            <div class="row my-3">
                                <div class="col-sm-5">
                                    <h5>Add a new resource:</h5>
                                </div>
                                <div class="col-sm-2">
                                </div>
                            </div>
                            <b-form-group
                                id="input-group-name"
                                label="Name:"
                                label-for="input-name"
                                description="The name will be unic."
                            >
                                <b-form-input
                                    id="input-name"
                                    v-model="new_resource.name"
                                    type="text"
                                    placeholder="Write resource name"
                                    
                                ></b-form-input>
                            </b-form-group>
                            <b-form-group id="input-group-type" label="Type:" label-for="input-type">
                                <b-form-select v-model="new_resource.type" :options="options_type" size="xl" id="input-type" class="mb-3">
                                    
                                </b-form-select>
                                <b-form-checkbox
                                    id="checkbox-external-resource"
                                    v-model="new_resource.external_resource"
                                    name="checkbox-external-resource"
                                    v-if=" new_resource.type == 'font'"
                                >
                                    External resource
                                </b-form-checkbox>
                            </b-form-group>

                            <b-form-group
                                id="input-group-value"
                                label="Value:"
                                label-for="input-value"
                            >
                                <b-form-input
                                    id="input-value"
                                    v-model="new_resource.value"
                                    type="text"
                                    placeholder="Write the name to show in the list"
                                ></b-form-input>

                            </b-form-group>

                            <b-form-group v-if=" new_resource.type != 'font'" id="input-group-position" label="Position:" label-for="input-position">
                                <b-form-select v-model="new_resource.position" :options="options_position" size="xl" id="input-position" class="mb-3">
                                    
                                </b-form-select>
                            </b-form-group>

                            
                            <b-form-group
                                id="input-group-url"
                                label="Link:"
                                label-for="input-url"
                            >
                                <b-form-input
                                    id="input-rul"
                                    v-model="new_resource.url"
                                    type="text"
                                    placeholder="Write path to resource"
                                    
                                ></b-form-input>
                            </b-form-group>
                            <div class="row">
                                <div class="col-sm-12 d-flex">
                                    <button @click="addResource()" class="btn btn-light mb-3">{{ new_resource.name? "Update":"Add"}}</button>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>
            </div>
        </div> -->
        <div class="row">
            <div class="col-sm-12 d-flex justify-content-end">
                <button @click="closeModal()" class="btn btn-light mr-2">Cancel</button>
                <button @click="saveChanges()" class="btn btn-light">Save</button>
            </div>
        </div>
        
  </div>
</template>

<script>


export default {
    name:"modal_resources",
    data: function () {
        return {
            resources:{
                script:[],
                style:[],
                font:[]
            },
            new_resource:{
                name:null,
                type:null,
                value:null,
                position:"head"
            },
            fields: ['name', 'type', 'active','position','options'],
            tab_active:0,
            styles:{
                button_option:{
                    color:"white"
                }
            },
            options_type:[
                { value: null, text: 'Select a type resource', disabled: true },
                { value: "font", text: 'Font' },
                { value: 'script', text: 'Js' },
                { value: 'style', text: 'Css' }
                
            ],
            options_position:[
                {value:"head", text:"Head"},
                {value:"footer", text:"Footer"}
            ]
        }
    },
    props:{
        editor:{
            
        }
    },
    computed:{
        
    },
    watch:{
        tab_active(newValue){
            if(newValue != 3)
                this.new_resource = {
                    name:null,
                    type:null,
                    value:null,
                    position:"head"
                }
        }
    },
    methods:{
        showDetail:function(data){
            this.tab_active = 3;
            this.new_resource = data.item;
        },
        removeResource(data){
            this.resources[data.item.type].splice(data.index,1); 

        },
        addResource(){
            this.resources[this.new_resource.type].push(this.new_resource);
            this.tab_active = 0;
            
        },
        closeModal(){
            this.editor.Modal.close();
        },
        saveChanges(){
            let template_resources = this.resources.font.concat(this.resources.style).concat(this.resources.script);
            this.editor.runCommand('save-template-resources',{ template_resources });
            this.editor.runCommand('load-list-typography');
            this.editor.runCommand('load-resources');

            this.closeModal();
        }
    },
    mounted(){

        let resources = editor.runCommand('filter-resources-duplicated');
        this.resources.style = resources.filter((item)=>{
            return item.type == "style"
        });

        this.resources.script = resources.filter((item)=>{
            return item.type == "script"
        });

        this.resources.font = resources.filter((item)=>{
            return item.type == "font"
        });
        
    }
}
</script>

<style lang="scss">
    .slim-btn{
        padding: 0.1rem 0.5rem !important;
        /* &:focus{
            box-shadow: 0 0 0 0.2rem #f8f9fa47 !important;
        } */
    }
    .btn-trash{
        & svg{
            & path{
                fill:#ff4242bd;
            }
        }   
    }
</style>